import {
    deepClone,
    handleQuestionRender,
    prepareValidationData,
    stringToObject,
} from "src/utils/helpers";
import { PageUniqueKeys } from "src/containers/QuestionnaireParent/QuestionnaireEnum";

export const evaluateSubmitButtonStatus = (
    currentQuestions: Array<any>,
    currentPage: any
): boolean => {
    let questions = deepClone(currentQuestions);
    const pageMetadata =
        currentPage?.metadata && stringToObject(currentPage?.metadata);

    const isPageOptional = pageMetadata?.isOptional === "true" || false;

    // only consider questions which are visible
    questions = questions.filter((question: any) =>
        handleQuestionRender(question, questions)
    );
    const response = prepareValidationData(questions);

    let buttonEnabled = false;
    let isOtherEmpty = false;

    const nothingRequired: boolean =
        response.length > 1 &&
        response.filter((r) => r[Object.keys(r)[1]] === false).length ===
            response.length;

    // need to optimise-todo
    for (let r = 0; r < response.length; r++) {
        const el = response[r];
        const key = Object.keys(el)[0];
        const isRequired = el[Object.keys(el)[1]] || false;
        const value = el[key];

        isOtherEmpty = value?.some((queChoices: any) => {
            // choice level validation - input validation and requirement validation
            if (
                queChoices.isValid === false ||
                (queChoices.isRequired && !queChoices.value)
            ) {
                return true;
            }

            const hasOther =
                (queChoices.metadata && queChoices?.metadata.has_other) ||
                false;

            //  here we check if the string only contains space or not
            const onlySpaces = (str: string) => {
                return str.trim().length === 0;
            };

            if (
                hasOther &&
                (!queChoices.value || onlySpaces(queChoices.value))
            ) {
                return true;
            }

            return (
                queChoices?.nodes &&
                queChoices?.nodes?.some((subChoice: any) => {
                    if (
                        subChoice &&
                        subChoice?.nodes &&
                        subChoice?.nodes.length > 0
                    ) {
                        return (
                            subChoice?.nodes &&
                            subChoice?.nodes.some((item: any) => {
                                if (item.metadata && item.selected) {
                                    const metaData: any = stringToObject(
                                        item.metadata
                                    );

                                    if (
                                        metaData &&
                                        metaData.has_other &&
                                        !item.value
                                    ) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                } else {
                                    return false;
                                }
                            })
                        );
                    } else if (subChoice.metadata && subChoice.selected) {
                        const metaData: any = stringToObject(
                            subChoice.metadata
                        );

                        if (
                            metaData &&
                            metaData.has_other &&
                            !subChoice.value
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                })
            );
        });

        if (isOtherEmpty) {
            buttonEnabled = false;
            break;
        }

        if (!isPageOptional) {
            const pageUniqueKeys = [
                PageUniqueKeys.insuranceTertiaryCardExistingClientPageV1,
                PageUniqueKeys.insuranceTertiaryCardNewClientPageV1,
            ]; // exclude value length for this pages

            if (nothingRequired) {
                // if all is not required
                if (
                    pageUniqueKeys?.includes(currentPage.unique_key) ||
                    value.length !== 0
                ) {
                    buttonEnabled = true;
                    break;
                } // if atleastr one question is valid
            } else {
                if (isRequired && value.length === 0) {
                    buttonEnabled = false;
                    break;
                } // if atleast one question is invalid

                if (r === response.length - 1) buttonEnabled = true; // if loops end and nothing invalid
            }
        } else {
            buttonEnabled = true;
        }
    }

    return buttonEnabled;
};
